/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

const DEFAULT_BASE = 10;

import {AbstractControl, ValidationErrors, Validators} from '@angular/forms';

export class CustomValidators {
  static readonly integerValidator = Validators.pattern('^-?\\d+$');

  static readonly stepValidator = (allowedDigitsAfterDecimal: number) => {
    return (control: {value: number}) => {
      if (
        !isNaN(control.value) &&
        (control.value * Math.pow(DEFAULT_BASE, allowedDigitsAfterDecimal)) %
          1 !==
          0
      ) {
        return {invalidStep: true};
      }
      return null;
    };
  };

  static readonly urlValidator = () => {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      try {
        new URL(control.value);
        return null;
      } catch {
        return {invalidUrl: true};
      }
    };
  };
}
